import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DomSanitizer, SafeStyle} from "@angular/platform-browser";

@Component({
  selector: 'w-textarea-field',
  templateUrl: './textarea-field.component.html',
  styleUrls: ['./textarea-field.component.scss']
})
export class TextareaFieldComponent implements OnInit {
  @Input() rowSpan: number = 1;
  @Input() value: string;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() label: string;
  @Input() hideLabel: boolean = false;
  @Input() placeholder: string;

  textAreaStyle: SafeStyle;
  containerStyle: SafeStyle;

  constructor(public domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    const textAreaHeight = 25 + ((this.rowSpan - 1) * 50);
    const textAreaStyle = `height: ${textAreaHeight}px; margin-top: 5px; margin-bottom: 5px;`;
    this.textAreaStyle = this.domSanitizer.bypassSecurityTrustStyle(textAreaStyle);
  }

}
